const keyboardDatePickerModalDocCompany = {
  label: 'Validade'
};

export default keyboardDatePickerModalDocCompany;
